
let timedTasksCollector = null
import {
    viewFileAPI, // 文件预览
    downloadFile // 文件下载
} from '@/api/upload.js'
import {
    postLogAdd,// 新增浏览记录
} from '@/api/sixKanban';

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}
/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

export function getQueryString(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

let tool = {
    // 新增浏览记录埋点
    postLogAddFun(name,id) {
        window.open(`#/detail/${id}`)

        // postLogAdd({
        //     actionName: name,
        //     lawId:id
        // }).then((res) => {
        //     if (res.status == 200) {
        //         window.open(`#/detail/${id}`)
        //     } else {}
        // })
    },
    // 缓存当前页面的data值
    setPageData(vm, newName) {
        let data = vm._data,
            name = vm.$route.name
        if (newName) {
            sessionStorage.setItem(newName, JSON.stringify(data))
        } else {
            sessionStorage.setItem(name, JSON.stringify(data))
        }
    },
    // 开启定时器
    openTimer(vm, newName) {
        this.closeTimer()
        window.timedTasksCollector = window.setInterval(() => {
            this.setPageData(vm, newName)
        }, 500)
    },
    // 关闭定时器
    closeTimer() {
        if (window.timedTasksCollector) {
            window.clearInterval(window.timedTasksCollector)
            window.timedTasksCollector = null
        }

    },

    // 文件预览
    handleReviewCreateA(item) {
        // var url = item.attachmentUrl + '?type=3'
        var url = item
        let doc = document,
            a = doc.createElement('a')
        if (doc.body.querySelector('#a-preview-pdf-temp')) {
            doc.body.removeChild(doc.body.querySelector('#a-preview-pdf-temp'))
        }
        a.id = 'a-preview-pdf-temp'
        a.setAttribute('target', '_blank')
        a.href = url
        doc.body.appendChild(a)
        a.click()
        doc.body.removeChild(a)
    },

    handleFileView(item) {
        // 改变按钮等待状态
        viewFileAPI({ fileID: item.attachmentId })
            .then(res => {
                // 预览处理
                this.handleReviewCreateA(res.previewUrl)
                // 按钮等待状态延迟关闭(用于有接口的情况)
                return false
            })
    },

    // 下载
    handleFileDownload(item) {
        // 改变按钮等待状态
        downloadFile({ fileID: item.attachmentId })
            .then(res => {
                if (res) {
                    let doc = document,
                        a = doc.createElement('a')
                    if (doc.body.querySelector('#a-down-pdf-temp')) {
                        doc.body.removeChild(doc.body.querySelector('#a-down-pdf-temp'))
                    }
                    a.id = 'a-down-pdf-temp'
                    a.setAttribute('target', '_blank')
                    a.href = res
                    doc.body.appendChild(a)
                    a.click()
                    doc.body.removeChild(a)
                }
            })
    },


    // 文件流下载  type 指定格式
    blobDownload(res, title, type) {
        let data = res.data;
        // 将文件流转为文件下载 
        let doc = document;
        if (type == 'type') {
            var blobNew = new Blob([data], { type: "xls/xlsx" })
        } else {
            var blobNew = data;
        }
        let a = doc.createElement("a");
        let href = window.URL.createObjectURL(blobNew);
        if (doc.body.querySelector("#a-download-pdf-temp")) {
            doc.body.removeChild(
                doc.body.querySelector("#a-download-pdf-temp")
            );
        }
        a.id = "a-download-pdf-temp";
        a.href = href;
        a.target = '_blank'
        // blobDownload
        var title = decodeURI(title)
        a.download = title; //下载后文件名
        document.body.appendChild(a);
        a.click(); //点击下载
        document.body.removeChild(a); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },

    formatField(data, fieldList) {
        data = { ...data };
        const a = {};
        fieldList.forEach((field) => {
            a[field] = data[field];
            delete data[field];
        });
        data.parmOthers = a;
        return data;
    }
}

export default tool




